import cn from 'classnames'
import React, { ReactNode } from 'react'

import style from './SettingsControlRow.style'

type SettingsControlRowProps = {
  title: string
  description?: string
  /** Right-aligned control (switch, pill + switch, etc.). */
  children?: ReactNode
  className?: string
}

/**
 * A label + description row with a right-aligned control, shared by the
 * Payment channels and Connected capabilities disclosures in the redesigned
 * physical card settings (EX-40354).
 */
export default function SettingsControlRow(
  props: SettingsControlRowProps,
): React.ReactElement {
  const { title, description, children, className = '' } = props

  return (
    <div className={cn('SettingsControlRow', className)} css={style}>
      <div className="SettingsControlRow-text">
        <div className="SettingsControlRow-title">{title}</div>
        {description && (
          <div className="SettingsControlRow-description">{description}</div>
        )}
      </div>
      {children && <div className="SettingsControlRow-control">{children}</div>}
    </div>
  )
}
